// extracted by mini-css-extract-plugin
export var fadeInOut = "_4f-3";
export var icon = "_4f-4";
export var savedIndicator = "_4f-2";
export var savingIndicator = "_4f-0";
export var spin = "_4f-1";